import { render, staticRenderFns } from "./SurveysAdminStats.vue?vue&type=template&id=9478c4fa&scoped=true&"
import script from "./SurveysAdminStats.vue?vue&type=script&lang=js&"
export * from "./SurveysAdminStats.vue?vue&type=script&lang=js&"
import style0 from "./SurveysAdminStats.vue?vue&type=style&index=0&id=9478c4fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9478c4fa",
  null
  
)

export default component.exports